import livro from 'imagens/livro.png'

export const livros = [
    {nome: 'psl1', id:1, src:livro },
    {nome: 'psl2', id:2, src:livro },
    {nome: 'psl3', id:3, src:livro },
    {nome: 'psl4', id:4, src:livro },
    {nome: 'psl5', id:5, src:livro }

]